var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnqSvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9752_233919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 1.5H11.7188C9.90938 1.5 8.4375 2.94923 8.4375 4.73077V7.5C8.4375 8.22923 8.09063 8.91231 7.5 9.34615C6.90937 8.91231 6.5625 8.22923 6.5625 7.5V4.73077C6.5625 2.94923 5.09062 1.5 3.28125 1.5H0.46875C0.20625 1.5 0 1.70308 0 1.96154V7.5C0 10.8138 2.72812 13.5 6.09375 13.5H8.90625C12.2719 13.5 15 10.8138 15 7.5V1.96154C15 1.70308 14.7937 1.5 14.5312 1.5ZM3.28125 2.42308C4.575 2.42308 5.625 3.45692 5.625 4.73077V7.5C5.625 8.34923 5.9625 9.16154 6.5625 9.76154C6.4125 9.78923 6.25313 9.80769 6.09375 9.80769C4.8 9.80769 3.75 8.77385 3.75 7.5V4.73077C3.77813 3.82615 3.35625 2.96769 2.625 2.42308H3.28125ZM6.09375 12.5769C3.24375 12.5769 0.9375 10.3062 0.9375 7.5V2.42308C2.025 2.68154 2.79375 3.63231 2.8125 4.73077V7.5C2.8125 9.28154 4.28438 10.7308 6.09375 10.7308C7.90312 10.7308 9.375 9.28154 9.375 7.5V4.73077C9.39375 3.63231 10.1625 2.68154 11.25 2.42308V7.5C11.25 10.3062 8.94375 12.5769 6.09375 12.5769ZM14.0625 7.5C14.0625 10.1215 12.0281 12.3185 9.375 12.5585C11.1281 11.46 12.1875 9.54923 12.1875 7.5V2.42308H13.5938C13.8562 2.42308 14.0625 2.62615 14.0625 2.88462V7.5Z",
    fill: "#2BFAAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9752_233919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 12,
    fill: "white",
    transform: "translate(0 1.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnqSvgLogo);
export default __webpack_public_path__ + "static/media/unqSvgLogo.789ee280.svg";
export { ForwardRef as ReactComponent };